import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { authInterceptorProviders } from './interceptors/auth.intercepor';
import { AppComponent } from './main/app.component';
import { LoginComponent } from './pages/login/login.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { WrapperComponent } from './controls/wrapper/wrapper.component';
import { CategoriesComponent } from './pages/categories/categories.component';
import { ProductsComponent } from './pages/products/products.component';
import { OrdersComponent } from './pages/orders/orders.component';
import { UsersComponent } from './pages/users/users.component';
import { EditCategoryComponent } from './pages/edit-category/edit-category.component';
import { EditProductComponent } from './pages/edit-product/edit-product.component';
import { OrderDetailComponent } from './pages/order-detail/order-detail.component';
import { OrderStatusPipe } from './pipes/order-status.pipe';
import { PaymentStatusPipe } from './pipes/payment-status.pipe';
import { DeliveryStatusPipe } from './pipes/delivery-status.pipe';
import { UserDetatailComponent } from './pages/user-detail/user-detail.component';
import { NewsComponent } from './pages/news/news.component';
import { EditNewsComponent } from './pages/edit-news/edit-news.component';
import { InputMaskModule } from '@ngneat/input-mask';
import { PushHistoryComponent } from './pages/push-history/push-history.component';
import { PushCreatorComponent } from './pages/push-creator/push-creator.component';
import { PaymentTypePipe } from './pipes/payment-type.pipe';
import { IconsComponent } from './controls/icons/icons.component';
import { NgbDateParserFormatter, NgbDatepickerI18n, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CustomDatepickerI18n } from './providers/ngbdatepikeri18n.provider';
import { NgbDateCustomParserFormatter } from './providers/ngbdatecustomparserformatter.provider';
import { InDevelopComponent } from './pages/in-develop/in-develop.component';
import { StoresComponent } from './pages/stores/stores/stores.component';
import { EditStoreComponent } from './pages/stores/edit-store/edit-store.component';
import { StoreMainInfoComponent } from './pages/stores/edit-store/store-main-info/store-main-info.component';
import { StoreProductReplacementComponent } from './pages/stores/edit-store/store-product-replacement/store-product-replacement.component';
import { SliderComponent } from './pages/slider/slider.component';
import { UserRolePipe } from './pipes/user-role.pipe';
import { AngularYandexMapsModule, YaConfig } from 'angular8-yandex-maps';
import { StorePromotionsComponent } from './pages/stores/store-promotions/store-promotions.component';
import { UserPromotionsComponent } from './controls/user-promotions/user-promotions.component';
import { BartendersComponent } from './pages/bartenders/bartenders/bartenders.component';
import { EditBartenderComponent } from './pages/bartenders/edit-bartender/edit-bartender.component';
import { MkoPushesComponent } from './pages/mko-pushes/mko-pushes.component';
import { ProductLinksComponent } from './pages/product-links/product-links.component';
import { EditCityComponent } from './pages/city/edit-city/edit-city.component';
import { CitiesComponent } from './pages/city/cities/cities.component';
import { ProductsSortComponent } from './pages/products-sort/products-sort.component';
import { FilterSortComponent } from './pages/filter-sort/filter-sort.component';
import { ListStoriesComponent } from './pages/story/list-stories/list-stories.component';
import { EditStoryComponent } from './pages/story/edit-story/edit-story.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CdkDrag, CdkDropList } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';

const mapConfig: YaConfig = {
  apikey: 'b0c8f145-a83a-4573-8eb2-83aed789d624',
  lang: 'ru_RU',
};

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DashboardComponent,
    WrapperComponent,
    CategoriesComponent,
    ProductsComponent,
    OrdersComponent,
    UsersComponent,
    EditCategoryComponent,
    EditProductComponent,
    OrderDetailComponent,
    OrderStatusPipe,
    PaymentStatusPipe,
    DeliveryStatusPipe,
    UserDetatailComponent,
    NewsComponent,
    EditNewsComponent,
    PushHistoryComponent,
    PushCreatorComponent,
    PaymentTypePipe,
    IconsComponent,
    InDevelopComponent,
    StoresComponent,
    EditStoreComponent,
    StoreMainInfoComponent,
    StoreProductReplacementComponent,
    BartendersComponent,
    EditBartenderComponent,
    SliderComponent,
    UserRolePipe,
    StorePromotionsComponent,
    UserPromotionsComponent,
    UserPromotionsComponent,
    MkoPushesComponent,
    ProductLinksComponent,
    EditCityComponent,
    CitiesComponent,
    ProductsSortComponent,
    FilterSortComponent,
    ListStoriesComponent,
    EditStoryComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    InputMaskModule,
    NgbModule,
    CdkDrag,
    CdkDropList,
    ScrollingModule,
    AngularYandexMapsModule.forRoot(mapConfig)
  ],
  providers: [
    authInterceptorProviders,
    { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
    { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter }, provideHttpClient(withInterceptorsFromDi()),
  ]
})
export class AppModule { }
